import React, { Component } from 'react';
import { Helmet } from "react-helmet";

import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Link } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image"
import { LazyLoadImage } from 'react-lazy-load-image-component';

import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import MailIcon from '@mui/icons-material/Mail';

import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Hidden from '@mui/material/Hidden';
import ServicesMenu from '../menus/ServicesMenu';
import MainMenu from '../menus/MainMenu';
import { Button } from '@mui/material';

import VideoPlayBackDialog from '../dialogs/VideoPlayBackDialog/VideoPlayBackDialog'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookSquare, faTwitterSquare, faInstagram, faMedium } from '@fortawesome/free-brands-svg-icons'

import wavy_bg from '../../images/wavy_bg.svg';
import development from '../../images/development.svg';
import buy from '../../images/buy.svg';
import maintenance from '../../images/maintenance.svg';
import social from '../../images/social.svg';
import startup from '../../images/startup.svg';
import WorkFasterDialog from './WorkFaster';

const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  fontSize: '2rem',
}));

const MenuItemTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  '&:hover': {
    color: theme.palette.grey[100],
    cursor: 'pointer',
  },
  lineHeight: "1.33",
  fontWeight: '600',
  marginBottom: theme.spacing(4),
}));

const MenuItemTypographyWhiteBg = styled(Typography)(({ theme }) => ({
  color: '#fff',
  lineHeight: "1.33",
  marginBottom: theme.spacing(4),
  fontWeight: '600',
}));

const MenuItemTypographyInactiveWhiteBg = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  '&:hover': {
    color: theme.palette.text.primary,
    cursor: 'pointer',
  },
  lineHeight: "1.33",
  marginBottom: theme.spacing(4),
  fontWeight: '600',
}));

const GatsbyImageStyled = styled(GatsbyImage)(({ theme }) => ({
  height: "calc(100vh - 1rem)",
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    paddingBottom: '2rem !important',
  },
  margin: "0",
  minHeight: "900px",
  /*backgroundImage: `url(${background_image})`,
   */
  backgroundSize: 'cover, auto',
  backgroundPosition: '50% 50%, 0px 0px',
}));

class HomeContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video_playback: false,
      work_faster_dialog_open: false,
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handlePostDemoNewVideoButtonClick = () => {
    window.location.href = "https://captionly.co";
  }

  handleViewHowToVideo = () => {
    this.setState({ video_playback: true });
  }

  closeHowToVideo = () => {
    this.setState({ video_playback: false });
  }

  handleVideoPlayBackClose = () => {
    this.setState({ watched_video: true });
  }

  handleContactSupport = () => {
    this.props.onContactSupportClick();
  }

  handleWorkFasterDialogOpen = () => {
    this.setState({ work_faster_dialog_open: true });
  }

  handleWorkFasterDialogClose = () => {
    this.setState({ work_faster_dialog_open: false });
  }

  render() {
    // Properties
    const { title, description, homeURL, data } = this.props;

    return (
      <Container maxWidth={false} disableGutters sx={{ paddingBottom: "10rem" }}>
        {/* <BackgroundImageStyled
          Tag="section"
          fluid={data.background_image.childImageSharp.gatsbyImageData}
          backgroundColor={`#040e18`}
        > */}

        <WorkFasterDialog open={this.state.work_faster_dialog_open} handleClose={this.handleWorkFasterDialogClose} />

        <Helmet>
          <html lang="en" />
          <title>{title}</title>
          <meta name="description" content={description} />
          <link rel="canonical" href="https://smartandnimble.com/" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={homeURL} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content="https://smartandnimble.com/thumbnail.png" />

          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={homeURL} />
          <meta property="twitter:title" content={title} />
          <meta property="twitter:description" content={description} />
          <meta property="twitter:image" content="https://smartandnimble.com/thumbnail.png" />

          <meta property="fb:pages" content="764314376980525" />
        </Helmet>

        <VideoPlayBackDialog
          open={this.state.video_playback}
          okText="Visit Captionly"
          onOkClick={this.handlePostDemoNewVideoButtonClick}
          cancelText="Close"
          onCancelClick={this.closeHowToVideo}
          onClose={this.handleVideoPlayBackClose}
          highlightOkButton={true}
        />

        <div style={{ display: "grid" }}>
          <GatsbyImageStyled
            style={{
              gridArea: "1/1",
              // You can set a maximum height for the image, if you wish.
              // maxHeight: 600,
              width: '100%'
            }}
            layout="fullWidth"
            alt=""
            // You can optionally force an aspect ratio for the generated image
            image={data.background_image.childImageSharp.gatsbyImageData}
          />
          <div
            style={{
              // By using the same grid area for both, they are stacked on top of each other
              gridArea: "1/1",
              position: "relative",
              // This centers the other elements inside the hero component
              display: "grid",
            }}
          >

            <Container maxWidth="lg">
              <Grid container spacing={2} direction="row" justifyContent="center" alignItems="stretch" style={{ paddingTop: '2rem' }}>
                <Grid item xs={12} md={4} style={{ textAlign: 'center' }}>
                  <GatsbyImage alt="Smart&Nimble Logo" image={data.logo_image.childImageSharp.gatsbyImageData} style={{ maxWidth: '100px', width: '60%' }} />
                </Grid>

                <Hidden only={['xs']}>
                  <Grid item xs={12} sm={2}>
                    <AnchorLink href='#services' style={{ textDecoration: 'none', color: 'inherit' }}>
                      <MenuItemTypography component="h4" >
                        {"Services".toUpperCase()}
                      </MenuItemTypography>
                    </AnchorLink>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <AnchorLink href='#why-us' style={{ textDecoration: 'none', color: 'inherit' }}>
                      <MenuItemTypography component="h4" >
                        {"Why Us".toUpperCase()}
                      </MenuItemTypography>
                    </AnchorLink>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <AnchorLink href='#media-and-resources' style={{ textDecoration: 'none', color: 'inherit' }}>
                      <MenuItemTypography component="h4" >
                        {"Media".toUpperCase()}
                      </MenuItemTypography>
                    </AnchorLink>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Link to={'/blog'} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <MenuItemTypography component="h4" >
                        {"Blog".toUpperCase()}
                      </MenuItemTypography>
                    </Link>
                  </Grid>
                </Hidden>

                <Hidden only={['xl', 'lg', 'md', 'sm']}>
                  <Grid item xs={12} style={{ position: 'absolute', top: '1.5rem', right: '1rem' }}>
                    <MainMenu onContactSupportClick={() => this.handleContactSupport()} />
                  </Grid>
                </Hidden>
              </Grid>

              <Grid container direction="column" justifyContent="center" alignItems="center" sx={{mt: '30px'}} >
                <Grid item xs={12} md={10}>
                  <Box key="box" sx={{ textAlign: 'center', marginTop: '20%' }} color="primary">
                    <Typography component="h2" variant="h2"
                      sx={{
                        fontFamily: '"Raleway", "Roboto", "Helvetica", "Arial", sans-serif',
                        fontWeight: "700", lineHeight: "1.33", marginBottom: '1rem',
                        textAlign: 'center', color: 'primary.contrastText'
                      }}
                    >
                      INTRODUCING CAPTIONLY
                    </Typography>
                    <Typography component="h3" variant="h4"
                      sx={{
                        fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
                        fontWeight: "400",
                        lineHeight: "1.33",
                        marginBottom: '1rem',
                        textAlign: 'center',
                        color: 'primary.contrastText',
                      }}
                    >
                      Make Your Videos Stand Out
                    </Typography>
                    {/*
                    <Typography component="h3" variant="h4"
                      className={classes.who_for_address}>
                      Founder of Smart&Nimble
                    </Typography>
                      */}

                    <Fab color="secondary" onClick={() => this.handleViewHowToVideo()} variant="extended"
                      sx={{ marginTop: 4, fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: "700", marginBottom: 4, marginRight: 2 }}>
                      <OndemandVideoIcon sx={{ marginRight: 1 }} />
                      Watch Video
                    </Fab>

                  </Box>
                </Grid>

              </Grid>
            </Container>
          </div>
        </div>

        <Container id='services' maxWidth={false}
          sx={{
            backgroundColor: "#1C1C1C",
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch">


              <Hidden only={['xs']}>
                <Grid item xs={12}>
                  <Typography component="h3" variant="h5" sx={theme => ({ color: theme.palette.grey[200], lineHeight: 1.33 })} >
                    {"Our Services".toUpperCase()}
                  </Typography>
                </Grid>

                <Grid id='services-cloud-computing' item xs={12} sm={3}>
                  <AnchorLink href='#services-cloud-computing' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography component="h4"
                      sx={theme => ({
                        color: theme.palette.grey[100],
                        lineHeight: 1.33,
                        marginBottom: 4,
                        fontWeight: 600,
                      })}
                    >
                      {"Work Faster".toUpperCase()}
                    </Typography>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-intelligent-algorithms' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypography component="h4" >
                      {"Work Smarter".toUpperCase()}
                    </MenuItemTypography>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-e-commerce' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypography component="h4" >
                      {"Sell More".toUpperCase()}
                    </MenuItemTypography>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-customer-experience' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypography component="h4" >
                      {"Delight Customers".toUpperCase()}
                    </MenuItemTypography>
                  </AnchorLink>
                </Grid>
              </Hidden>


              <Hidden only={['xl', 'lg', 'md', 'sm']}>
                <Grid item xs={12}>
                  <ServicesMenu service="cloud_computing" />
                </Grid>
              </Hidden>



              <Grid id='cloud-computing' item xs={12} md={6} align="left">
                <Typography component="h4" variant="h4" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Ramping Up Your Product Development"}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"We are so lucky to live in the times when enormous computing power, data processing capabilities, and the talent of world‑class engineers are literally at our fingertips."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"We are only limited by our imagination and the ability to uncover problems worth solving."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Are you leveraging this capability in your business, or do you often find yourself reinventing the wheel?"}
                </Typography>
                <Button variant="contained" color="primary" onClick={() => this.handleWorkFasterDialogOpen()}>
                  <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33 }} align="center">
                    {"Learn More"}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} sm={10} md={6} style={{ paddingBottom: 0, marginBottom: "20px" }}>
                <LazyLoadImage alt="Work Faster" width="100%" effect="opacity" src={development} />
              </Grid>


            </Grid>
          </Container>
        </Container>

        <Container maxWidth={false}
          sx={{
            backgroundColor: 'backgroundColor',
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch" >


              <Hidden only={['xs']}>
                <Grid id='services-intelligent-algorithms' item xs={12} sm={3}>
                  <AnchorLink href='#services-cloud-computing' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyInactiveWhiteBg component="h4" >
                      {"Work Faster".toUpperCase()}
                    </MenuItemTypographyInactiveWhiteBg>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-intelligent-algorithms' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyWhiteBg component="h4" >
                      {"Work Smarter".toUpperCase()}
                    </MenuItemTypographyWhiteBg>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-e-commerce' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyInactiveWhiteBg component="h4" >
                      {"Sell More".toUpperCase()}
                    </MenuItemTypographyInactiveWhiteBg>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-customer-experience' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyInactiveWhiteBg component="h4" >
                      {"Delight Customers".toUpperCase()}
                    </MenuItemTypographyInactiveWhiteBg>
                  </AnchorLink>
                </Grid>
              </Hidden>


              <Hidden only={['xl', 'lg', 'md', 'sm']}>
                <Grid item xs={12}>
                  <ServicesMenu service="intelligent_algorithms" />
                </Grid>
              </Hidden>


              <Hidden only={['xl', 'lg', 'md']}>
                <Grid id='intelligent-algorithms' item xs={12} md={6} align="left">
                  <Typography component="h4" variant="h4" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Empowering You to Work Smarter"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"From finance and fashion to agriculture and energy production."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"More and more industries reinvent themselves by integrating artificial intelligence to automate their processes and liberate humans from mundane, repetitive tasks."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Are you empowering your employees to think creatively by freeing up their time through the adoption of intelligent algorithms?"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }} align="center">
                    {"Learn More"}
                  </Typography>
                </Grid>
              </Hidden>

              <Grid item xs={12} sm={10} md={6} style={{ paddingBottom: 0, marginBottom: "20px" }}>
                <LazyLoadImage alt="Work Smarter" width="100%" effect="opacity" src={maintenance} />
              </Grid>

              <Hidden only={['sm', 'xs']}>
                <Grid id='intelligent-algorithms' item xs={12} md={6} align="left">
                  <Typography component="h4" variant="h4" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Empowering You to Work Smarter"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"From finance and fashion to agriculture and energy production."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"More and more industries reinvent themselves by integrating artificial intelligence to automate their processes and liberate humans from mundane, repetitive tasks."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Are you empowering your employees to think creatively by freeing up their time through the adoption of intelligent algorithms?"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }} align="center">
                    {"Learn More"}
                  </Typography>
                </Grid>
              </Hidden>


            </Grid>
          </Container>
        </Container>


        <Container maxWidth={false}
          sx={{
            backgroundColor: "#1C1C1C",
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch" >


              <Hidden only={['xs']}>

                <Grid id='services-e-commerce' item xs={12} sm={3}>
                  <AnchorLink href='#services-cloud-computing' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypography component="h4" >
                      {"Work Faster".toUpperCase()}
                    </MenuItemTypography>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-intelligent-algorithms' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypography component="h4" >
                      {"Work Smarter".toUpperCase()}
                    </MenuItemTypography>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-e-commerce' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography component="h4"
                      sx={theme => ({
                        color: theme.palette.grey[100],
                        lineHeight: 1.33,
                        marginBottom: 4,
                        fontWeight: 600,
                      })}
                    >
                      {"Sell More".toUpperCase()}
                    </Typography>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-customer-experience' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypography component="h4" >
                      {"Delight Customers".toUpperCase()}
                    </MenuItemTypography>
                  </AnchorLink>
                </Grid>
              </Hidden>


              <Hidden only={['xl', 'lg', 'md', 'sm']}>
                <Grid item xs={12}>
                  <ServicesMenu service="e-commerce" />
                </Grid>
              </Hidden>



              <Grid id='e-commerce' item xs={12} md={6} align="left">
                <Typography component="h4" variant="h4" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Helping You Sell More"}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Businesses thrive when they reach out to their customers where they spend most of their time."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"The growing percentage of retail purchases are made over the Internet while the payment methods are becoming more diverse and secure."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Are you capable of replicating the in‑store experience in your online store?"}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }} align="center">
                  {"Learn More"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={10} md={6} style={{ paddingBottom: 0, marginBottom: "20px" }}>
                <LazyLoadImage alt="Sell More" width="100%" effect="opacity" src={buy} />
              </Grid>


            </Grid>
          </Container>
        </Container>



        <Container maxWidth={false}
          sx={{
            backgroundColor: 'backgroundColor',
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch" >


              <Hidden only={['xs']}>
                <Grid id='services-customer-experience' item xs={12} sm={3}>
                  <AnchorLink href='#services-cloud-computing' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyInactiveWhiteBg component="h4" >
                      {"Work Faster".toUpperCase()}
                    </MenuItemTypographyInactiveWhiteBg>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-intelligent-algorithms' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyInactiveWhiteBg component="h4" >
                      {"Work Smarter".toUpperCase()}
                    </MenuItemTypographyInactiveWhiteBg>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-e-commerce' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyInactiveWhiteBg component="h4" >
                      {"Sell More".toUpperCase()}
                    </MenuItemTypographyInactiveWhiteBg>
                  </AnchorLink>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AnchorLink href='#services-customer-experience' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItemTypographyWhiteBg component="h4" >
                      {"Delight Customers".toUpperCase()}
                    </MenuItemTypographyWhiteBg>
                  </AnchorLink>
                </Grid>
              </Hidden>


              <Hidden only={['xl', 'lg', 'md', 'sm']}>
                <Grid item xs={12}>
                  <ServicesMenu service="customer_experience" />
                </Grid>
              </Hidden>


              <Hidden only={['xl', 'lg', 'md']}>
                <Grid id='customer-experience' item xs={12} md={6} align="left">
                  <Typography component="h4" variant="h4" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Delighting Your Customers"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"The experience economy is on the rise."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"While the Internet has helped us stay in touch over distance, the new generations are seeking a community and a sense of companionship more than ever."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Have you found a way to delight your customers by providing unforgettable, immersive, Instagram-friendly experiences?"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }} align="center">
                    {"Learn More"}
                  </Typography>
                </Grid>
              </Hidden>

              <Grid item xs={12} sm={10} md={6} style={{ paddingBottom: 0, marginBottom: "20px" }}>
                <LazyLoadImage alt="Delight Your Customers" width="100%" effect="opacity" src={social} />
              </Grid>

              <Hidden only={['sm', 'xs']}>
                <Grid id='customer-experience' item xs={12} md={6} align="left">
                  <Typography component="h4" variant="h4" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Delighting Your Customers"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"The experience economy is on the rise."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"While the Internet has helped us stay in touch over distance, the new generations are seeking a community and a sense of companionship more than ever."}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                    {"Have you found a way to delight your customers by providing unforgettable, immersive, Instagram-friendly experiences?"}
                  </Typography>
                  <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }} align="center">
                    {"Learn More"}
                  </Typography>
                </Grid>
              </Hidden>


            </Grid>
          </Container>
        </Container>

        <Container id='why-us' maxWidth={false}
          sx={{
            backgroundColor: "#1C1C1C",
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >

          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch" >

              <Grid item xs={12}>
                <Typography component="h3" variant="h5" sx={theme => ({ color: theme.palette.grey[200], lineHeight: "1.33", textAlign: 'center', marginBottom: 0 })}>
                  {"Why Us".toUpperCase()}
                </Typography>
              </Grid>

              <Grid item xs={10} sm={4} md={3} style={{ textAlign: 'center' }}>
                <GatsbyImage image={data.dmitri_lihhatsov_photo.childImageSharp.gatsbyImageData} alt="Dmitri Lihhatsov - Director at Smart&Nimble" style={{ maxWidth: '320px', width: '100%' }} />
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4, marginTop: '2rem', textAlign: 'left' }}>
                  {"My name is Dmitri Lihhatsov, and I'm the director of Smart&Nimble, a Public Speaker, and Investor who partners with entrepreneurs around the world and helps them skyrocket their businesses."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4, marginTop: '2rem', textAlign: 'left' }}>
                  {"Read More of My Personal Story"}
                </Typography>
              </Grid>
              <Grid item xs={10} sm={8} md={8} style={{ textAlign: 'left' }}>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"At Smart&Nimble, we believe in the power of intelligent machines to help the creatives flourish."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"In everything we do, we aim to augment human creativity with the computational power available in the Cloud to solve meaningful business problems."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"The way we make this happen is by fixing broken processes in industries like Finance and E‑Commerce by applying machine learning and disciplined strategic thinking."}
                </Typography>
              </Grid>

            </Grid>

          </Container>
        </Container>

        <Container maxWidth={false}
          sx={{
            backgroundColor: "#1C1C1C",
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >

          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch" >
              <Grid item xs={10} md={5} align="left">
                <Typography component="h4" variant="h4" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"What We Do"}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"At Smart&Nimble, we are in the consulting business. We help our clients look at their problems from a different angle and then offer possible bespoke solutions that we implement for them."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"We help businesses rediscover their identity and deploy intelligent systems that take them to the next level resulting in deeper customer relationships and stronger bottom line."}
                </Typography>
                <Typography component="p" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }} align="center">
                  {"Learn More"}
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={6} style={{ paddingBottom: 0, marginBottom: "20px" }}>
                <LazyLoadImage alt="Work Faster" width="100%" effect="opacity" src={startup} />
              </Grid>

            </Grid>
          </Container>
        </Container>

        {/* Media & Resources */}

        <Container id='media-and-resources' maxWidth={false}
          sx={{
            backgroundColor: 'backgroundColor',
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 6,
            paddingBottom: 6,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6} direction="row" justifyContent="center" alignItems="stretch" >

              <Grid item xs={12}>
                <Typography component="h3" variant="h5" sx={{ color: '#fff', lineHeight: "1.33", textAlign: 'center', marginBottom: '1rem' }}>
                  {"Media & Resources".toUpperCase()}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} align="left">
                <Typography component="h4" variant="h4" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Personal Development"}
                </Typography>
                <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"At Smart&Nimble, we believe that personal development and business excellence are interdependent. The level your business is at is in direct correlation with the level of your thinking."}
                </Typography>
                <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"As businesses become more automated by leveraging AI, emotional intelligence - or EQ - starts playing a more vital role in humans."}
                </Typography>
                <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"We never settle in our personal growth, and we find the discovery of new ways of thinking exciting!"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={8} md={6} >
                <iframe title="Smart&Nimble - Personal Development Playlist" style={{ width: '100%', height: 315 }} src="https://www.youtube-nocookie.com/embed/videoseries?list=PLlpkiwAKxPGSUt5RB_FpypwBIaZ9Uc7Jx&cc_lang_pref=en&cc_load_policy=1" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </Grid>


              <Hidden only={['sm', 'xs']}>
                <Grid item xs={12} sm={8} md={6}>
                  <iframe title="Smart&Nimble Monday Talk" src="https://open.spotify.com/embed-podcast/show/5xb1Sk0YUVEU9SU1QQ6cfr" width="100%" height="232" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                </Grid>
              </Hidden>

              <Grid item xs={12} md={6} align="left">
                <Typography component="h4" variant="h4" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Smart&Nimble Monday Talk"}
                </Typography>
                <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Our weekly podcasts are about 10-15 minutes long, which is ideal to listen while commuting."}
                </Typography>
                <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Occasionally, we invite guests to discuss a topic, which we would like to understand on a deeper level."}
                </Typography>
                <Typography component="p" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.33, marginBottom: 4 }}>
                  {"Such topics include psychology, artificial intelligence, behavioural economics, digital marketing, and self development."}
                </Typography>
              </Grid>

              <Hidden only={['xl', 'lg', 'md']}>
                <Grid item xs={12} sm={8} md={6}>
                  <iframe title="Smart&Nimble Monday Talk" src="https://open.spotify.com/embed-podcast/show/5xb1Sk0YUVEU9SU1QQ6cfr" width="100%" height="232" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                </Grid>
              </Hidden>

            </Grid>
          </Container>
        </Container>

        {/* END Media & Resources */}



        <Container maxWidth={false}
          sx={theme => ({
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: '15vh',
            paddingBottom: '15vh',
            backgroundImage: `url(${wavy_bg}), linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.dark})`,
            backgroundSize: 'cover, auto',
            backgroundPosition: '50% 50%, 0px 0px',
          })}
        >
          <Container maxWidth="lg">

            <Grid container spacing={10} direction="row" justifyContent="center" alignItems="stretch" style={{ marginBottom: '1rem' }}>
              <Grid item xs={12}>
                <Typography component="h3" variant="h2" align="center" color="textPrimary" gutterBottom
                  sx={{ fontWeight: '700', color: 'primary.contrastText' }}>
                  Ready to get started?
                </Typography>
              </Grid>

              {/*
                <Grid item xs={12} sm={4} md={3} lg={3} style={{textAlign: 'center'}}>
                    <Fab color="secondary" onClick={() => this.handleViewHowToVideo()} variant="extended">
                      <OndemandVideoIcon sx={{marginRight: 1}} />
                      Book Discovery Session
                    </Fab>
                </Grid>
                */}

              <Grid item xs={12} sm={4} md={3} lg={3} style={{ textAlign: 'center' }}>
                <Fab color="secondary" variant="extended"
                  onClick={() => this.handleContactSupport()}>
                  <MailIcon sx={{ marginRight: 1 }} />
                  Get in Touch
                </Fab>
              </Grid>
            </Grid>

          </Container>
        </Container>

        {/* Footer Links */}

        <Container maxWidth={false}
          sx={{
            backgroundColor: 'backgroundColor',
            textAlign: 'center',
            fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
            paddingTop: 12,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={7} direction="row" justifyContent="center" alignItems="stretch" >

              <Grid item xs={3} sm={2} md={1}>
                <a href="https://www.facebook.com/smartandnimble" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIconStyled icon={faFacebookSquare} />
                </a>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <a href="https://www.instagram.com/smartandnimble" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIconStyled icon={faInstagram} />
                </a>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <a href="https://www.twitter.com/smartandnimble" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIconStyled icon={faTwitterSquare} />
                </a>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <a href="https://www.medium.com/smartandnimble" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIconStyled icon={faMedium} />
                </a>
              </Grid>
              {/*
              <Grid item xs={1}>
                <FontAwesomeIconStyled icon={faTelegramPlane} />
              </Grid>
              */}

            </Grid>
          </Container>
        </Container>

        {/* END Footer Links */}


      </Container>

    );
  }
}

HomeContent.propTypes = {
  title: PropTypes.string.isRequired
};

export default HomeContent;
